module.exports = __webpack_public_path__ + "img/close-icon-dark.3e67c604.svg";